<template>
  <vue-final-modal
    v-bind="$attrs"
    classes="modal-container"
    content-class="modal-content"
    v-on="$listeners"
  >
    <template>
      <div class="modal__content">
        <p>{{ messageText }}</p>
      </div>
      <div class="modal__action">
        <button
          class="bg-sh-warning text-white rounded m-1 p-3 focus:outline-none cursor-pointer"
          @click="$emit('cancel', close)"
        >
          {{ declineText }}
        </button>
        <button
          class="bg-sh-primary text-white rounded m-1 p-3 focus:outline-none cursor-pointer"
          @click="$emit('confirm', close)"
        >
          {{ confirmText }}
        </button>
      </div>
    </template>
  </vue-final-modal>
</template>

<script>
export default {
  name: 'ConfirmationModal',
  inheritAttrs: false,
  props: {
    messageText: {
      type: String,
      required: true
    },
    confirmText: {
      type: String,
      required: true
    },
    declineText: {
      type: String,
      required: true
    }
  },
  methods: {
    close() {
      this.$emit('input', false);
    }
  }
};
</script>

<style scoped>
::v-deep .modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
::v-deep .modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 90%;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  max-width: 400px;
}
::v-deep .modal-content p {
  font-size: 14px;
}
.modal__content {
  flex-grow: 1;
  overflow-y: auto;
}
.modal__action {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  padding: 1rem 0 0;
}

button {
  flex: 1 1 50%;
}
</style>
